import { jsx as _jsx } from "nativewind/jsx-runtime";
import { font } from '@/constant/font';
import React from 'react';
import { Platform, View } from 'react-native';
import styled from 'styled-components/native';
export default function CurvedDateText({ date = '', containerSize = 84, fontSize = 9, charColor, fontFamily, }) {
    const characters = date.split('');
    const radius = containerSize / 2;
    const totalChars = characters.length;
    const startAngle = 110;
    const endAngle = 14;
    const angleStep = totalChars > 1 ? (endAngle - startAngle) / (totalChars - 1) : 0;
    return (_jsx(Container, { style: { width: containerSize, height: containerSize }, children: characters.map((char, index) => {
            const angle = startAngle + angleStep * index;
            const radian = (angle * Math.PI) / 180;
            const textRadius = radius - 8;
            const x = radius + textRadius * Math.cos(radian);
            const y = radius + textRadius * Math.sin(radian);
            const textRotation = angle - 90;
            const wrapperStyle = Object.assign({ position: 'absolute', transform: [{ rotate: `${textRotation}deg` }], left: x - fontSize / 2 + 1 }, Platform.select({
                ios: {
                    top: y - fontSize / 2 - 4,
                },
                android: {
                    top: y - fontSize / 2 - 4,
                },
            }));
            const textStyle = Object.assign({ fontSize }, (fontFamily ? { fontFamily } : {}));
            return (_jsx(View, { style: wrapperStyle, children: _jsx(Character, { color: charColor, style: textStyle, children: char }) }, `${char}-${index}`));
        }) }));
}
const Container = styled.View({
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
});
const Character = styled.Text(({ color }) => ({
    color: color,
    textAlign: 'center',
    fontFamily: font.gumiRomance,
}));
